export * from './replace.directive';



// WEBPACK FOOTER //
// ./src/app/directives/replace/index.ts